<mat-form-field appearance="outline" color="accent" floatLabel="always" [hideRequiredMarker]="hideRequiredMarker"
  [ngClass]="[
    'c-input-text',
    type ? 'c-input-text--type-' + (type | toCssClassName) : '',
    inputAlignment ? 'c-input-text--alignment-' + (inputAlignment | toCssClassName) : '',
    isFullWide ? 'u-mat-full' : '',
    textSize ? 'c-input-text--size-' + (textSize | toCssClassName) : '',
  ]">
  <mat-label
    [matTooltip]="label">
    <ng-container *ngIf="required">{{ label }}</ng-container>
    <ng-container *ngIf="!required">{{ label | optionalFieldTranslate }}</ng-container>
    <app-bui-tooltip-icon *ngIf="tooltip"
      [tooltip]="tooltip">
    </app-bui-tooltip-icon>
  </mat-label>
  <mat-icon matPrefix *ngIf="prefix && (isBuiIconMaterialIconType | wrapFn: prefixType)"
    [svgIcon]="prefixType + ':' + prefix">
  </mat-icon>
  <span class="c-input-text__prefix" matPrefix *ngIf="prefix && prefixType === 'noSpaceString'"
    [ngClass]="[
      'c-input-text__prefix--type-' + (prefixType | toCssClassName)
    ]">
    {{ prefix }}
  </span>
  <input
    matInput
    [attr.type]="type"
    [attr.placeholder]="placeholder"
    [attr.tabindex]="tabindex"
    [attr.autocomplete]="autocomplete"
    [formControl]="$any(ngControl?.control) || defaultFormControl"
    (focus)="onFocus($event)"
    (input)="onInput($event)">
  <app-bui-spinner matSuffix *ngIf="!isSuffixClickable && suffixType === 'spinner'"
    [spinnerType]="'inline'"
    [spinnerHasOverlay]="false"
    [spinnerSize]="'icon-normal'">
  </app-bui-spinner>
  <button *ngIf="isSuffixClickable && suffix && (isBuiIconMaterialIconType | wrapFn: suffixType)"
    mat-icon-button
    matSuffix
    [attr.tabindex]="suffixTabindex"
    (mouseup)="suffixClicked($event)">
    <mat-icon *ngIf="suffix && (isBuiIconMaterialIconType | wrapFn: suffixType)"
      [svgIcon]="suffixType + ':' + suffix">
    </mat-icon>
  </button>
  <mat-error *ngIf="ngControl?.errors?.required">
    {{ 'VALIDATIONS.FIELD_REQUIRED' | translate }}
  </mat-error>
  <mat-error *ngIf="ngControl?.errors?.invalidRegex">
    {{ 'VALIDATIONS.INVALID_REGEX_ENTERED' | translate }}
  </mat-error>
  <mat-error *ngFor="let error of validationErrors">
    <ng-container [ngTemplateOutlet]="error.tmpRef"></ng-container>
  </mat-error>
</mat-form-field>
